import { PropTypes } from 'prop-types';
import React from 'react';

import HomepageHeroLatelyBottom from './HomepageHeroLatelyBottom';
import HomepageHeroLatelyTop from './HomepageHeroLatelyTop';

const HomepageHeroLately = ({
  comments,
  header,
  mosaic,
  mosaicQuote,
  mostRead,
}) => {
  console.log("MOST_READ", mostRead)
  return (
    <div>
      <HomepageHeroLatelyTop comments={comments} header={header} />
      <HomepageHeroLatelyBottom
        mosaic={mosaic}
        mosaicQuote={mosaicQuote}
        mostRead={mostRead}
      />
    </div>
  );
};

HomepageHeroLately.propTypes = {
  comments: PropTypes.array,
  header: PropTypes.array,
  mosaic: PropTypes.array,
  mosaicQuote: PropTypes.object,
  mostRead: PropTypes.array,
};

export default HomepageHeroLately;
